<section class="loading-card">
  <div class="loading-frame">
    <div class="loader-wrapper" aria-hidden="true">
      <div class="dice">
        <div class="face front">
          <span class="dot center"></span>
        </div>

        <div class="face back">
          <span class="dot top-left"></span>
          <span class="dot bottom-right"></span>
        </div>

        <div class="face right">
          <span class="dot top-left"></span>
          <span class="dot center"></span>
          <span class="dot bottom-right"></span>
        </div>

        <div class="face left">
          <span class="dot top-left"></span>
          <span class="dot top-right"></span>
          <span class="dot bottom-left"></span>
          <span class="dot bottom-right"></span>
        </div>

        <div class="face top">
          <span class="dot top-left"></span>
          <span class="dot top-right"></span>
          <span class="dot center"></span>
          <span class="dot bottom-left"></span>
          <span class="dot bottom-right"></span>
        </div>

        <div class="face bottom">
          <span class="dot top-left"></span>
          <span class="dot top-right"></span>
          <span class="dot middle-left"></span>
          <span class="dot middle-right"></span>
          <span class="dot bottom-left"></span>
          <span class="dot bottom-right"></span>
        </div>
      </div>
    </div>

    <div class="loading-copy">
      <p class="loading-flavor">{{ flavorText }}</p>
    </div>
  </div>
</section>
